export class Adal5User {
    authenticated: boolean;
    username: string;
    error: string;
    profile: any;
    token: string;
}
